console.log("Julie d' Prax — " + document.currentScript.id);

//import "./style.scss";

import { useEffect, useState, render } from "@wordpress/element";

import { useBlockProps } from "@wordpress/block-editor";

export function timeToString(time, inMils = false) {
  const mins = Math.floor(time / 60);
  const secs = (Math.floor(time % 60) < 10 ? "0" : "") + Math.floor(time % 60);

  if (inMils === false) {
    return mins + ":" + secs;
  }

  const mils = Math.floor((time * 1000) % 1000)
    .toString()
    .padStart(3, "0");

  return mins + ":" + secs + "." + mils;
}

export function newID() {
  return getRandomInt(1, 9999999999).toString().padStart(10, "0");

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
  }
}

export const rateMarks = [
  { value: 0.5 },
  { value: 1 },
  { value: 2 },
  { value: 6 },
];

export const volumeMarks = [
  { value: 0, label: "Mute" },
  //   { value: 0.1 },
  { value: 0.25 },
  //   { value: 0.3 },
  //   { value: 0.4 },
  { value: 0.5 },
  //   { value: 0.6 },
  { value: 0.75 },
  //   { value: 0.8 },
  //   { value: 0.9 },
  { value: 1, label: "100" },
];

export function masterVolumeMarks(vol) {
  const quarter = vol * 25;
  const half = vol * 50;
  const volumeMarks = [
    { value: 0, label: "Mute" },
    { value: 0.25, label: quarter.toFixed() },
    { value: 0.5, label: half.toFixed() },
    { value: 0.75, label: (vol * 100 - half - quarter).toFixed() },
    { value: 1, label: (vol * 100).toFixed() },
  ];
  return volumeMarks;
}

export function renderBlock(Block, metadata) {
  console.log("View Script - " + metadata.title);

  window.addEventListener("DOMContentLoaded", () => {
    console.log("View DOMContentLoaded");

    const elements = document.querySelectorAll(
      ".wp-block-" + metadata.attributes.class.default
    );

    for (const el in elements) {
      const element = elements[el];
      if (element.firstChild) {
        const attributes = { ...element.firstChild.dataset };

        attributes["class"] = element.firstChild.className;

        render(
          <Block
            attributes={attributes}
            mode='view'
            isSelected='true'
          />,
          element
        );
      }
    }
  });
}
export function saveBlock(Block, attributes) {
  console.log("Juliete M. Belanger —  saveBlock");

  const blockProps = { ...useBlockProps.save() };
  blockProps.className = blockProps.className + " " + attributes.playersize;

  return (
    attributes.class && (
      <section {...blockProps}>
        <Block
          attributes={attributes}
          mode='save'
        />
      </section>
    )
  );
}

const angleTable = [
  { digit: 1, start: 30, stop: 55, max: 58 },
  { digit: 2, start: 0, stop: 30, max: 88 },
  { digit: 3, start: 330, stop: 360, max: 116 },
  { digit: 4, start: 300, stop: 330, max: 146 },
  { digit: 5, start: 270, stop: 300, max: 177 },
  { digit: 6, start: 240, stop: 270, max: 205 },
  { digit: 7, start: 210, stop: 240, max: 236 },
  { digit: 8, start: 180, stop: 210, max: 264 },
  { digit: 9, start: 150, stop: 180, max: 298 },
  { digit: 0, start: 120, stop: 150, max: 327 },
  { digit: -1, start: 60, stop: 120, max: 0 },
];

export function fingerMaxAngle(angle) {
  var max, digit;
  angleTable.forEach((element) => {
    if (angle >= element.start && angle <= element.stop) {
      max = element.max;
      digit = element.digit;
    }
  });
  return [max, digit];
}

export function translateDialedNumber(dialedNumber) {
  switch (dialedNumber.length) {
    case 0:
      return <span class='lamp-off'>( 000 ) 000 - 0000</span>;

    case 1:
      return (
        <>
          <span class='lamp-off'>( 000 ) 000 - 000</span>
          <span class='lamp-on'>{dialedNumber}</span>
        </>
      );

    case 2:
      return (
        <>
          <span class='lamp-off'>( 000 ) 000 - 00</span>
          <span class='lamp-on'>{dialedNumber}</span>
        </>
      );
    case 3:
      if (dialedNumber[1] === "0" || dialedNumber[1] === "1") {
        return (
          <>
            <span class='lamp-on'>( {dialedNumber} ) </span>
            <span class='lamp-off'>000 - </span>
          </>
        );
      } else {
        return (
          <>
            <span class='lamp-off'>( 000 ) </span>
            <span class='lamp-on'>{dialedNumber} - </span>
          </>
        );
      }

    case 4:
    case 5:
      if (dialedNumber[1] === "0" || dialedNumber[1] === "1") {
        return (
          <span class='lamp-on'>
            {" ( "}
            {dialedNumber.slice(0, 3)}
            {" ) "}
            {dialedNumber.slice(3)}
          </span>
        );
      } else
        return (
          <>
            <span class='lamp-off'>( 000 )</span>
            <span class='lamp-on'>
              {dialedNumber.slice(0, 3)}
              {" - "}
              {dialedNumber.slice(3)}
            </span>
          </>
        );

    case 6:
      if (dialedNumber[1] === "0" || dialedNumber[1] === "1") {
        return (
          <span class='lamp-on'>
            {" ( "}
            {dialedNumber.slice(0, 3)}
            {" ) "}
            {dialedNumber.slice(3)}
          </span>
        );
      } else
        return (
          <>
            <span class='lamp-off'>( 000 )</span>
            <span class='lamp-on'>
              {dialedNumber.slice(0, 3)}
              {" - "}
              {dialedNumber.slice(3)}
            </span>
          </>
        );
    case 7:
      if (dialedNumber[1] === "0" || dialedNumber[1] === "1") {
        return (
          <span class='lamp-on'>
            {" ( "}
            {dialedNumber.slice(0, 3)}
            {" ) "}
            {dialedNumber.slice(3, 6)}
            {" - "}
            {dialedNumber.slice(6)}
          </span>
        );
      } else
        return (
          <>
            <span class='lamp-off'>( 000 )</span>
            <span class='lamp-on'>
              {dialedNumber.slice(0, 3)}
              {" - "}
              {dialedNumber.slice(3)}
            </span>
          </>
        );

    case 8:
    case 9:
    case 10:
      return (
        <span class='lamp-on'>
          {" ( "}
          {dialedNumber.slice(0, 3)}
          {" ) "}
          {dialedNumber.slice(3, 6)}
          {" - "}
          {dialedNumber.slice(6)}
        </span>
      );

    default:
      return <span class='lamp-off'>( 000 ) 000 - 0000</span>;
  }
}

export function Key({
  keyClass,
  lampClass,
  valueVar,
  label,
  labelFirst,
  onClick,
}) {
  const kClass = keyClass !== undefined ? keyClass : "key";
  const lClass = lampClass !== undefined ? lampClass : "lamp";
  return (
    <div
      class={kClass}
      onClick={onClick}
    >
      {labelFirst === true && <label>{label}</label>}
      <div class={lClass}>
        <span>{valueVar}</span>
      </div>
      {labelFirst !== true && <label>{label}</label>}
    </div>
  );
}
